// extracted by mini-css-extract-plugin
module.exports = {"field-reference":"AppAddDeclarationDebtor_field-reference_3C5hQ","period--read-only":"AppAddDeclarationDebtor_period--read-only_3zSXw"};